export const REDIRECT_REFERRER = Object.freeze('ssLogInReferral');
export const LOCAL_STORAGE_LAT = "searchLocationLat";
export const LOCAL_STORAGE_LNG = "searchLocationLng";